﻿import Startup from './Startup';

let startup: Startup = new Startup();

startup.run();